import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { Exam } from './types';

export const initialState: {
  isLoading: boolean;
  isSuccess: boolean;
  error: string | Error | null;
  data: Exam[];
} = {
  isLoading: false,
  isSuccess: false,
  error: null,
  data: [],
};

export const examsList = createSlice({
  name: 'examsList',
  initialState: initialState,
  reducers: {
    getExamsAction: (state) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.error = null;
    },

    getExamsSuccessAction: (state, { payload }: PayloadAction<{ data: Exam[] }>) => {
      state.data = payload.data;
      state.isSuccess = true;
      state.isLoading = false;
      state.error = null;
    },

    getExamsErrorAction: (state, { payload: error }) => {
      state.error = error;
      state.isLoading = false;
      state.isSuccess = false;
    },
  },
});

export const { getExamsAction, getExamsSuccessAction, getExamsErrorAction } = examsList.actions;

export default examsList.reducer;
